<template>
  <div class="top-count">
    <div class="list">
      <div :class="['item', item.key]" v-for="(item, i) in countList">
        <div class="item-con">
          <span class="name">
            {{ item.name }}
          </span>
          <span class="num">
            {{ item.num ? item.num : '-' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMapData } from '../../../api/getMapData';

export default {
  name: 'TopCount',
  props: {
    type: {
      type: String,
      default: '',
    },
    adCode: {
      type: Number,
      default: 0,
    },
    pointName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      countList: [
        {
          name: '会员总数',
          key: 'membersTotal',
          num: null,
        },
        {
          name: '企业会员',
          key: 'enterpriseMembersTotal',
          num: null,
        },
        {
          name: '团体会员',
          key: 'groupMembersTotal',
          num: null,
        },
        {
          name: '个人会员',
          key: 'individualMembersTotal',
          num: null,
        },
      ],
      numData: {
        total: 2442281,
        company: 1468267,
        team: 61712,
        individuals: 61712,
      },
      countData: {
        会员总数: '67660',
        企业会员: '53209',
        团体会员: '2093',
        个体会员: '12358',
      },
    };
  },
  watch: {
    type(n) {
      this.getData();
    },
    pointName(n) {
      this.getData();
    },
  },
  methods: {
    getData() {
      this.$api.screen
        .getMembershipStatistics({
          name: this.pointName ? this.pointName : this.type === 'Country' ? '全国' : '广东省',
        })
        .then((res) => {
          let { data } = res.data;
          this.countList = this.countList.map((item) => {
            item.num = data[item.key] ? data[item.key].toLocaleString() : null;
            return item;
          });
        });

      // getMapData(this.type).then(res => {
      //   let name = this.type === 'Country' ? '省份' : '地市';
      //   this.countData = res.filter(item => {
      //     let pointName = this.pointName ? this.pointName : '合计';
      //     return item[name] === pointName
      //   })[0];
      //   this.filterData();
      // })
    },
    filterData() {
      this.countList.map((item) => {
        let val = this.countData[item.name];
        item.num = Number(val);
        if (item.num) {
          item.num = item.num.toLocaleString();
        }
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.list {
  .flex-center();
  color: #fff;
  /*padding: 20px 0;*/

  .item {
    width: 265px;
    .flex-center();

    &::before {
      content: '';
      width: 124px;
      height: 124px;
      background-size: 100% 100% !important;
    }

    &.membersTotal {
      &::before {
        background: url('~img/home/top-count-total.png') no-repeat;
      }
    }

    &.enterpriseMembersTotal {
      &::before {
        background: url('~img/home/top-count-company.png') no-repeat;
      }
    }

    &.groupMembersTotal {
      &::before {
        background: url('~img/home/top-count-team.png') no-repeat;
      }
    }

    &.individualMembersTotal {
      &::before {
        background: url('~img/home/top-count-individuals.png') no-repeat;
      }
    }
  }

  .item-con {
    height: 124px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: normal;
    color: #fff;
    line-height: 24px;
    margin: -15px 0 0 -10px;

    .num {
      font-size: 32px;
      font-family: Geometr706 BlkCn BT;
      /*font-family: Geometr706 BlkCn BT;*/
      font-weight: 900;
      color: #fff;
      line-height: 24px;
      margin-top: 14px;
    }
  }
}
</style>
